import { Injectable } from "@angular/core";
import { DRCTScheduleList, DRCTWebConfig } from "@drct-web-apps/ui-types";
import { ReplaySubject } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class UiServiceWebSession {
  private readonly _sessionReady: ReplaySubject<boolean> = new ReplaySubject(1);
  get sessionReady(): ReplaySubject<boolean> {
    return this._sessionReady;
  }
  
  private _webConfig: DRCTWebConfig | null = null;
  get webConfig(): DRCTWebConfig | null {
    return this._webConfig;
  }
  set webConfig(value: DRCTWebConfig | null) {
    this._webConfig    = value;
    this._initComplete = true;
    this._sessionReady.next(true);
  }

  private _defaultMsg = 'Loading/Initializing...';
  private _message = '';
  get message(): string {
    return ((this._message === null) || (this._message === undefined) || (this._message.trim() === "")) 
           ? this._defaultMsg: this._message;
  }
  set message(value: string) {
    this._message = value;
  }

  private _userName = '';
  get userName(): string {
    return this._userName;
  }
  set userName(value: string) {
    this._userName = value;
  }

  private _currentDate = '';
  get currentDate(): string {
    return this._currentDate;
  }
  set currentDate(value: string) {
    this._currentDate = value;
  }

  private _loggedIn = false;
  get loggedIn(): boolean {
    return this._loggedIn;
  }
  set loggedIn(value: boolean) {
    this._loggedIn = value;
  }

  private _userRole = '';
  get userRole(): string {
    return this._userRole;
  }
  set userRole(value: string) {
    this._userRole = value;
  }

  private _initComplete = false;
  get initComplete(): boolean {
    return this._initComplete;
  }

  private _scheduleInfo: DRCTScheduleList[] = [];
  get scheduleInfo(): DRCTScheduleList[] {
    return this._scheduleInfo;
  }
  set scheduleInfo(value: DRCTScheduleList[]) {
    this._scheduleInfo = value;
  }

  private _flashScreenClosed = false;
  get flashScreenClosed(): boolean {
    return this._flashScreenClosed;
  }
  set flashScreenClosed(value: boolean) {
    this._flashScreenClosed = value;
  }

  public isAdmin(): boolean {
    return (this._userRole === 'ADMIN');
  }
  public isFinance(): boolean {
    return (this._userRole === 'FNACE');
  }
  public isStaff(): boolean {
    return (this._userRole === 'STAFF');
  }

  public resetObjets(): void {
    this._webConfig    = null;
    this._message      = '';
    this._userName     = '';
    this._currentDate  = '';
    this._loggedIn     = false;
    this._userRole     = '';
    this._initComplete = false;
    this._scheduleInfo = [];
    this._flashScreenClosed = false;
  }
} 